import React, { useRef, useState, useEffect } from "react";
import logo from "../images/familee_tree_logo.svg";
import { useFormik } from 'formik';
import { Link } from "react-router-dom";
import { forgotPasswordVerifyOtp } from "../services/ApiServices";
import { ForgotPassword } from "./ForgotPassword";
import { toast } from "react-toastify";


const validate = values => {
  const errors = {};
  if (!values.emailOTP || values.emailOTP.length < 6) {
    errors.otp = 'Please enter a valid 6-digit verification OTP.';
  }
  return errors;
};

const VerifyOtp = ({emailId}) => {
    const [show, setShow ] = useState(false);
  const [emailOTP, setEmailOTP] = useState(new Array(6).fill(''));
  const [countdown, setCountdown] = useState(52);
  const inputs = useRef([]);

  const formik = useFormik({
    initialValues: { emailOTP: '' },
    validate,
    onSubmit: async (values, { setSubmitting }) => {
      try {

        const payload = {
            emailId: emailId,
            emailOTP: values?.emailOTP
        }
        const verifyForgotPasswordOtp = await forgotPasswordVerifyOtp(payload)
        if(verifyForgotPasswordOtp.status === 200) {
            toast.success(verifyForgotPasswordOtp.data.messsage);
            setShow(true)
            return;
        }

      } catch (error) {
        toast.error('Something Wrong')
      } finally {
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [countdown]);

  const handleChange = (e, index) => {
    if (isNaN(e.target.value)) return;
    const value = e.target.value;
    const newOtp = [...emailOTP];
    newOtp[index] = value;

    if (value && index < emailOTP.length - 1) {
      inputs.current[index + 1].focus();
    }

    setEmailOTP(newOtp);
    formik.setFieldValue('emailOTP', newOtp.join(''));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !emailOTP[index] && index > 0) {
      inputs.current[index - 1].focus();
    }
  };



  return (
    !show ? 
    <React.Fragment>
      <div className="login-page">
        <div className="login-container">
          <img src={logo} alt="FamileeTree" className="logo" />
          <form onSubmit={formik.handleSubmit}>
            <label htmlFor="otp">We have sent a 6-digit verification code.</label>
            <div className="otp-inputs">
              {emailOTP.map((value, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="otp-input"
                  ref={(el) => (inputs.current[index] = el)}
                  value={value}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
            {formik.touched.emailOTP && formik.errors.emailOTP ? (
              <p className="error-message">{formik.errors.emailOTP}</p>
            ) : null}
            <button className="verify-button" type="submit">Next</button>
          </form>
          <div>
            <span>
              {countdown > 0 
                ? `Send verification code again in ${countdown}s.` 
                : <Link to='/ForgotPasswordEmailId'><span className="login-forget"> Resend OTP?</span></Link>
              }
            </span>
          </div>
        </div>
      </div>
    </React.Fragment> : <ForgotPassword emailId={emailId}/>
  );
};

export default VerifyOtp;